import PropTypes from "prop-types"
import React from "react"

import Box from "../../components/Box"
import Container from "../../components/UI/Container"
import Form from "./form"
import Heading from "../../components/Heading"
import NewsletterWrapper, { NewsletterFormWrapper } from "./newsletter.style"

const Newsletter = ({
  textArea,
  buttonStyle,
  title,
  description,
  pathname,
}) => {
  return (
    <NewsletterWrapper>
      <Container width="1154px">
        <Box {...textArea}>
          <Heading as="h2" content="Subscribe to our newsletter" {...title} />
        </Box>
        <NewsletterFormWrapper>
          <Form pathname={pathname} />
        </NewsletterFormWrapper>
      </Container>
    </NewsletterWrapper>
  )
}

Newsletter.propTypes = {
  textArea: PropTypes.object,
  buttonArea: PropTypes.object,
  buttonStyle: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
}

Newsletter.defaultProps = {
  textArea: {
    mb: ["20px", "40px", "40px", "0", "0"],
    pr: ["0", "0", "0", "80px", "100px"],
    width: ["100%", "100%", "100%", "100%", "54%"],
  },
  title: {
    fontSize: ["26px", "32px", "40px", "40px"],
    fontWeight: "700",
    color: "#fff",
    lineHeight: ["36px", "50px"],
    mb: ["32px"],
    textAlign: ["center", "center", "center", "left", "left"],
  },
  description: {
    fontSize: ["20px", "24px", "24px", "28px", "28px"],
    fontWeight: "300",
    color: "#fefefe",
    lineHeight: "1.7",
    mb: 0,
    textAlign: ["center", "center", "center", "left", "left"],
  },
  buttonStyle: {
    type: "button",
    fontSize: "14px",
    fontWeight: "700",
    pl: "30px",
    pr: "30px",
  },
}

export default Newsletter
